






































import CFMDialog from '@/scripts/CFMDialog';
import { Component } from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui';
import { toastApiError, toastResultError } from '@/helpers/apiToast';
import { CFMDTOFteRoleOptionView } from '@/scripts/services/ClientApiAuto';

/**
 * "Hesaba Dahil Roller": FTE hesabina girecek rollerin secimi (User.Role.IsIncludedInFte).
 * CFM'in sagdan acilan dialog kalibi (modal-side, CFMDialog). Secim tam listedir: isaretli
 * roller dahil, digerleri haric; kayit sonrasi ust bilesen hesabi yeniler (save-succeeded).
 */
@Component<FteRoleDialog>({})
export default class FteRoleDialog extends CFMDialog {
  roles: CFMDTOFteRoleOptionView[] = [];

  /** Yalnizca basarili yuklemeden sonra true: hata durumunda "rol yok" yazmak yanlis olurdu. */
  isLoaded = false;

  isSaving = false;

  get selectedCount(): number {
    return this.roles.filter((r) => r.IsIncludedInFte).length;
  }

  async created() {
    await this.loadRoles();
  }

  setAll(value: boolean) {
    this.roles.forEach((r) => { r.IsIncludedInFte = value; });
  }

  async loadRoles() {
    try {
      const response = await this.apiClient.fte.fteGetRoles();
      if (!response.data.IsSuccess) {
        toastResultError(response.data);
        return;
      }
      // Kopya: isaretler kaydedilmeden sunucudan gelen listeyi bozmasin.
      this.roles = (response.data.Data || []).map((x) => ({ ...x }));
      this.isLoaded = true;
    } catch (e) {
      toastApiError(e);
    }
  }

  /** Bos secim: Kaydet dugmesi zaten pasif, sunucu da reddeder (FteAtLeastOneRoleRequired). */
  async onSubmit() {
    const ids = this.roles.filter((r) => r.IsIncludedInFte).map((r) => <number>r.RoleId);
    this.isSaving = true;
    blockui.blockModal(this);
    try {
      const response = await this.apiClient.fte.fteSaveRoles(ids);
      if (response.data.IsSuccess) {
        toastr.success(this.translate('save_successfully'));
        this.saveSucceeded();
        this.close();
      } else {
        toastResultError(response.data);
      }
    } catch (e) {
      toastApiError(e);
    } finally {
      blockui.unBlockModal();
      this.isSaving = false;
    }
  }
}
